import { UserDepartment } from "@/api/user/models";
import { RoutePathEnum } from "@/routes/paths";

export const DEPARTMENT_NAV_ITEMS: Record<UserDepartment, RoutePathEnum[]> = {
  [UserDepartment.CASTING]: [
    RoutePathEnum.TALENTS,
    RoutePathEnum.TALENTS_ARCHIVED,
    RoutePathEnum.JOBS,
    RoutePathEnum.COLLABORATORS,
  ],
  [UserDepartment.PHOTO_LAB]: [RoutePathEnum.TALENTS, RoutePathEnum.COLLABORATORS],
  [UserDepartment.REBOUCAS]: [RoutePathEnum.SCHEDULE, RoutePathEnum.REJECTED, RoutePathEnum.COLLABORATORS],
  [UserDepartment.FRADIQUE]: [RoutePathEnum.SCHEDULE, RoutePathEnum.REJECTED, RoutePathEnum.COLLABORATORS],
};
